import React, { createContext, useContext, useState } from "react";

interface ConversationContextProps {
  hasConversation: boolean;
  setHasConversation: React.Dispatch<React.SetStateAction<boolean>>;
  conversationLoading: boolean;
  setConversationLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConversationContext = createContext<ConversationContextProps | null>(
  null,
);

export default function ConversationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [hasConversation, setHasConversation] = useState<boolean>(false);
  const [conversationLoading, setConversationLoading] = useState<boolean>(true);

  return (
    <ConversationContext.Provider
      value={{
        hasConversation,
        setHasConversation,
        conversationLoading,
        setConversationLoading,
      }}
    >
      {children}
    </ConversationContext.Provider>
  );
}

export const useConversation = () => {
  const context = useContext(ConversationContext);
  if (!context) {
    throw new Error("useConversation must be used within ConversationProvider");
  }
  return context;
};
